import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { UserCircle2, Calendar, MapPin, ArrowRight, Maximize2, X } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import { api } from "@/lib/api";
import { formatDateLong } from "@/lib/format";
import { Logo } from "@/components/Logo";
import { BottomTab } from "@/components/BottomTab";

export default function Home() {
  const nav = useNavigate();
  const [event, setEvent] = useState(null);
  const [qrOpen, setQrOpen] = useState(false);
  const appUrl = typeof window !== "undefined" ? window.location.origin : "";

  useEffect(() => {
    api.get("/event").then((r) => setEvent(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen pb-24 bg-surface" data-testid="home-page">
      <header
        className="bg-black flex items-center justify-between px-5 pb-5"
        style={{ paddingTop: "calc(var(--safe-top) + 20px)" }}
      >
        <Logo size="md" />
        <h1 className="text-2xl font-black text-white">Eventi</h1>
        <button data-testid="admin-entry-btn" onClick={() => nav("/admin")} className="text-white">
          <UserCircle2 size={38} strokeWidth={1.8} />
        </button>
      </header>

      <div className="px-4 pt-4">
        <div
          data-testid="event-card"
          onClick={() => nav("/event")}
          className="bg-black rounded-3xl p-6 cursor-pointer active:scale-[0.99] transition-transform"
        >
          <div className="flex justify-center py-6">
            <Logo size="lg" />
          </div>

          <p className="text-brand font-black text-xl tracking-wide mt-2 leading-tight">
            {(event?.name || "THE MAD BAR").toUpperCase()} — {(event?.subtitle || "First Edition").toUpperCase()}
          </p>

          <div className="mt-5 flex items-center gap-3 text-white">
            <Calendar className="text-brand" size={24} />
            <span className="text-lg font-bold">
              {event ? formatDateLong(event.date_iso) : "—"}
            </span>
          </div>
          <div className="mt-3 flex items-center gap-3 text-white">
            <MapPin className="text-brand" size={24} />
            <span className="text-lg font-bold">{event?.location_name || "—"}</span>
          </div>

          <button
            data-testid="open-event-btn"
            className="mt-6 w-full bg-brand text-onbrand rounded-2xl py-4 font-black text-lg flex items-center justify-center gap-2 active:opacity-90"
          >
            Apri evento <ArrowRight size={22} strokeWidth={3} />
          </button>
        </div>

        <button data-testid="qr-card" onClick={() => setQrOpen(true)} className="w-full text-left bg-surface2 rounded-3xl p-4 mt-4 flex items-center gap-4 active:scale-[0.99] transition-transform">
          <div className="bg-white p-1.5 rounded-xl border border-surface3 shrink-0">
            <QRCodeCanvas value={appUrl} size={58} bgColor="#ffffff" fgColor="#000000" level="M" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-black text-onsurface flex items-center gap-2">Condividi con un amico! <Maximize2 size={16} className="text-onsurface3" /></p>
            <p className="text-sm text-onsurface3 mt-1 font-secondary leading-snug">Inquadra il QR code e apri l'app THE MAD BAR!</p>
          </div>
        </button>

        <div className="flex justify-center pt-5">
          <button
            data-testid="privacy-link"
            onClick={() => nav("/privacy")}
            className="text-[11px] text-onsurface3 underline underline-offset-2 font-secondary"
          >
            Privacy & Cookie Policy
          </button>
        </div>
      </div>

      {qrOpen && createPortal(
        <div data-testid="qr-fullscreen" className="fixed inset-0 z-[100] bg-black flex flex-col items-center justify-center p-8" onClick={() => setQrOpen(false)}>
          <button data-testid="qr-fullscreen-close" className="absolute top-6 right-6 text-white"><X size={30} /></button>
          <Logo size="md" className="mb-8" />
          <div className="bg-white p-5 rounded-3xl">
            <QRCodeCanvas value={appUrl} size={260} bgColor="#ffffff" fgColor="#000000" level="M" />
          </div>
          <p className="text-white text-center font-black text-xl mt-8 max-w-xs leading-snug">Condividi con un amico!</p>
          <p className="text-onsurface3 text-center font-secondary mt-2 max-w-xs leading-snug">Inquadra il QR code e apri l'app THE MAD BAR!</p>
        </div>,
        document.body
      )}

      <BottomTab />
    </div>
  );
}
